import { decode as decodeGs1 } from 'gs1-parser';

export function parseGs1(raw) {
  try {
    const parsed = decodeGs1(raw);
    return {
      gtin: parsed.GTIN || null,
      lot: parsed.lot || null,
      expiry: parsed.exp instanceof Date
        ? `${parsed.exp.getFullYear()}-${String(parsed.exp.getMonth() + 1).padStart(2, '0')}-${String(parsed.exp.getDate()).padStart(2, '0')}`
        : null,
    };
  } catch {
    return null;
  }
}

export function isExpired(dateStr) {
  if (!dateStr) return null;
  return dateStr < new Date().toISOString().split('T')[0];
}

// The server names stock with no location "Unassigned"; show it translated
export function locationLabel(balance, t) {
  return balance.location_id ? balance.location_name : t('inventory:scanner.unassigned');
}
